var Bow = function (quality) {
  return {
    slot: 'off_hand',
    type: 'bow',
    quality: quality,
    bowDamageMod: quality * 0.4,
    perception: Math.round(1 + quality * 2.5),
    speed: quality * 0.4,
  };
};
module.exports = Bow;
